import { ChipStyled } from 'features/yardCheck/components/YardCheckStatusChip/YardCheckStatusStyled';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { YARD_CHECK_ITEM_TYPE, YARD_CHECK_ITEM_TYPE_LABEL } from 'utils/constants';

const { MISSING, NEW, UPDATED } = YARD_CHECK_ITEM_TYPE;

const YardCheckStatusChip = ({ status, width = 100, sx }) => {
    const chipColor = useMemo(() => {
        switch (status) {
            case MISSING:
                return 'var(--color-red)';
            case NEW:
                return 'var(--color-yellow)';
            case UPDATED:
                return 'var(--color-blue)';
            default:
                return 'var(--color-green)';
        }
    }, [status]);

    return <ChipStyled label={YARD_CHECK_ITEM_TYPE_LABEL[status]} background={chipColor} width={width} size="small" sx={sx} />;
};

YardCheckStatusChip.propTypes = {
    status: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sx: PropTypes.object,
};

export default YardCheckStatusChip;
